import { FunctionComponent } from 'react';
import { Box } from '../../../../Components/Box/Box';
import { Tag } from '../../../../Components/Tag/Tag';
import { MoonListCellProps } from './MoonListCellProps';

export const MoonListCell: FunctionComponent<MoonListCellProps> = ({ moonList }) => {
  return (
    <Box className="h-full">
      <div className="h-full v-stack items-start justify-between">
        <div>
          <h3 className="text-text font-bold">{moonList.name}</h3>
        </div>

        <div className="w-full mt-6 h-stack items-center justify-between">
          <h5 className="text-xs text-text-secondary">{moonList.author.login}</h5>
          <Tag data={`${moonList.moonCount}`} icon="/images/icons/moon_red.svg" />
        </div>
      </div>
    </Box>
  );
};
